"use strict";
const core_1 = require("@angular/core");
exports.IINAXCONFIGSERVICE_TOKEN = new core_1.OpaqueToken('IInaxConfigService');
